/* BESOCKS (04/11/2026): (1) traduce los valores de los filtros según el idioma activo; (2) en móvil los filtros del panel salen cerrados por defecto */
(function () {
  var D = {
    en: { 'Amarillo': 'Yellow', 'Azul': 'Blue', 'Blanco': 'White', 'Granate': 'Burgundy', 'Gris': 'Grey', 'Morado': 'Purple', 'Marrón': 'Brown', 'Negro': 'Black', 'Off White': 'Off White', 'Rosa': 'Pink', 'Verde': 'Green', 'Barrio Sésamo': 'Sesame Street', 'Comida': 'Food', 'Viajes': 'Travel', 'Animales': 'Animals', 'Naturaleza': 'Nature', 'Deporte': 'Sports', 'Básicos': 'Basics', 'Otros': 'Other' },
    fr: { 'Amarillo': 'Jaune', 'Azul': 'Bleu', 'Blanco': 'Blanc', 'Granate': 'Bordeaux', 'Gris': 'Gris', 'Morado': 'Violet', 'Marrón': 'Marron', 'Negro': 'Noir', 'Off White': 'Blanc cassé', 'Rosa': 'Rose', 'Verde': 'Vert', 'Multicolor': 'Multicolore', 'Barrio Sésamo': 'Sesame Street', 'Comida': 'Nourriture', 'Viajes': 'Voyages', 'Animales': 'Animaux', 'Naturaleza': 'Nature', 'Deporte': 'Sport', 'Básicos': 'Basiques', 'Otros': 'Autres' },
    de: { 'Amarillo': 'Gelb', 'Azul': 'Blau', 'Blanco': 'Weiß', 'Granate': 'Bordeaux', 'Gris': 'Grau', 'Morado': 'Lila', 'Marrón': 'Braun', 'Negro': 'Schwarz', 'Off White': 'Off-White', 'Rosa': 'Rosa', 'Verde': 'Grün', 'Multicolor': 'Mehrfarbig', 'Barrio Sésamo': 'Sesamstraße', 'Comida': 'Essen', 'Viajes': 'Reisen', 'Animales': 'Tiere', 'Naturaleza': 'Natur', 'Deporte': 'Sport', 'Básicos': 'Basics', 'Otros': 'Sonstiges' },
    it: { 'Amarillo': 'Giallo', 'Azul': 'Blu', 'Blanco': 'Bianco', 'Granate': 'Bordeaux', 'Gris': 'Grigio', 'Morado': 'Viola', 'Marrón': 'Marrone', 'Negro': 'Nero', 'Off White': 'Off White', 'Rosa': 'Rosa', 'Verde': 'Verde', 'Multicolor': 'Multicolore', 'Barrio Sésamo': 'Sesame Street', 'Comida': 'Cibo', 'Viajes': 'Viaggi', 'Animales': 'Animali', 'Naturaleza': 'Natura', 'Deporte': 'Sport', 'Básicos': 'Basic', 'Otros': 'Altro' }
  };
  var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
  var map = D[lang];
  var mobile = window.matchMedia('(max-width: 749px)');
  var state = {}; /* id del panel -> abierto (solo si lo ha tocado la persona) */
  var busy = false, timer = null;

  function translate() {
    if (!map) return;
    var roots = document.querySelectorAll('.facets, .facets-block-wrapper, #filters-drawer, facet-remove-component, .filter-remove-buttons, .active-facets');
    roots.forEach(function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = w.nextNode())) {
        var t = n.nodeValue.trim();
        if (t && map[t] && n.nodeValue.indexOf(t) !== -1) n.nodeValue = n.nodeValue.replace(t, map[t]);
      }
      root.querySelectorAll('[aria-label],[data-label]').forEach(function (el) {
        ['aria-label', 'data-label'].forEach(function (a) {
          var v = el.getAttribute(a);
          if (v && map[v]) el.setAttribute(a, map[v]);
        });
      });
    });
  }

  function collapse() {
    if (!mobile.matches) return;
    document.querySelectorAll('#filters-drawer details.facets__panel').forEach(function (d) {
      var want = state[d.id] === true;
      if (d.open !== want) { if (want) d.setAttribute('open', ''); else d.removeAttribute('open'); }
    });
  }

  /* recuerda lo que abre o cierra la persona (clic real en el titulo del filtro) */
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('#filters-drawer summary.facets__summary');
    if (!s) return;
    var d = s.parentElement;
    state[d.id] = !d.open;
  }, true);

  function run() {
    busy = true;
    translate();
    collapse();
    busy = false;
  }
  function schedule() {
    if (busy) return;
    clearTimeout(timer);
    timer = setTimeout(run, 30);
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
